import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ModalModule } from 'ngx-bootstrap/modal';
import { ManageEntityLocationModule } from 'src/app/shared/manage-entity-location/manage-entity-location.module';
import { UploadReqUpdateLocationModalComponent } from './upload-req-update-location-modal.component';

@NgModule({
  declarations: [UploadReqUpdateLocationModalComponent],
  imports: [
    CommonModule,
    ModalModule.forRoot(),
    ManageEntityLocationModule
  ],
  exports: [UploadReqUpdateLocationModalComponent],
  entryComponents: [UploadReqUpdateLocationModalComponent]
})
export class UploadReqUpdateLocationModalModule { }
